import BaseApiClient from '../BaseApiClient';
import { PriorityInterface } from '@interfaces/Priority.interface';
import { SelectOptionsResolver } from '@ui/SelectField/types';
import { ListDataParams } from '@api-client/types';

export class ApiDocumentCategory extends BaseApiClient {
  /**
   * Get all items
   */
  async all(documentTemplates: boolean): Promise<Array<PriorityInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get(
          `/document-categories?filter[documentTemplates]=${documentTemplates}&page[size]=999`
        )
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  optionsResolver: SelectOptionsResolver = async () => {
    const items = await this.all(false);
    return items
      ? items.map((i) => ({ value: `${i.id}`, label: i.name }))
      : null;
  };

  async filter(listData: ListDataParams): Promise<Array<PriorityInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList('/document-categories?page[size]=999', listData)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { documentCategoryQueryKeys } from './query-keys';
export {
  useDocumentCategoryAllQuery,
  useDocumentCategoryFilterQuery
} from './use-document-category-queries';

